module.exports = __webpack_public_path__ + "static/img/4.7ec0763.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/4.png
// module id = sPaY
// module chunks = 0